var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-navbar', {
    staticClass: "layout-navbar align-items-lg-center bg-success-darker container-p-x",
    attrs: {
      "toggleable": "lg",
      "variant": _vm.getLayoutNavbarBg()
    }
  }, [_c('b-navbar-brand', {
    staticClass: "app-brand demo d-lg-none py-0 mr-4",
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "app-brand-logo demo"
  }, [_vm.$store.getters.generic.settings && _vm.$store.getters.generic.settings.dashboard_logo ? _c('img', {
    attrs: {
      "src": _vm.backend_url + _vm.$store.getters.generic.settings.dashboard_logo,
      "alt": "img"
    }
  }) : _vm._e()])]), _vm._v(" "), _vm.sidenavToggle ? _c('b-navbar-nav', {
    staticClass: "layout-sidenav-toggle d-lg-none align-items-lg-center mr-auto"
  }, [_c('a', {
    staticClass: "nav-item nav-link px-0 mr-lg-4",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.toggleSidenav
    }
  }, [_c('i', {
    staticClass: "ion ion-md-menu text-large align-middle"
  })])]) : _vm._e(), _vm._v(" "), _c('b-navbar-toggle', {
    attrs: {
      "target": "app-layout-navbar"
    }
  }), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "is-nav": "",
      "id": "app-layout-navbar"
    }
  }, [_c('hr', {
    staticClass: "d-lg-none w-100 my-2"
  }), _vm._v(" "), _vm.fleets.length > 0 ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('multiselect', {
    staticClass: "select-bg",
    attrs: {
      "options": _vm.fleets,
      "allow-empty": false,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": true,
      "preserve-search": true,
      "clearable": false,
      "placeholder": _vm.$t('choose_fleet'),
      "label": "label",
      "track-by": "value",
      "showLabels": false,
      "maxHeight": 200
    },
    on: {
      "input": function input($event) {
        return _vm.refresh_fleet();
      }
    },
    model: {
      value: _vm.selected_fleet,
      callback: function callback($$v) {
        _vm.selected_fleet = $$v;
      },
      expression: "selected_fleet"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(_vm._s(_vm.$t('no_result')))]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.$t('no_options')))])])], 1) : _vm._e(), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "align-items-lg-center ml-auto"
  }, [_c('b-nav', {
    staticClass: "tabs-alt",
    attrs: {
      "tabs": ""
    }
  }, [_c('b-nav-item', {
    staticClass: "map_btn",
    attrs: {
      "to": {
        name: 'map'
      },
      "active": _vm.$route.name == 'map'
    }
  }, [_c('i', {
    staticClass: "ion ion-ios-map"
  }), _vm._v("  \n          " + _vm._s(_vm.$t("map")) + "\n        ")]), _vm._v(" "), _vm._l(_vm.menu_list, function (item) {
    return _c('div', {
      key: item.title
    }, [_c('b-nav-item', {
      attrs: {
        "active": item.name === _vm.$route.name,
        "to": item.path
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v("  " + _vm._s(_vm.$t(item.title)))])], 1);
  })], 2), _vm._v(" "), _vm.$route.name == 'map' ? [_c('div', {
    staticClass: "nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25"
  }, [_vm._v("|")]), _vm._v(" "), _c('b-nav-item-dropdown', {
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('span', {
    staticClass: "d-inline-flex flex-lg-row-reverse align-items-center align-middle"
  }, [_c('i', {
    staticClass: "fa fa-bell"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "bg-primary text-center text-white font-weight-bold mt-n1 p-1"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('notifications')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right mt-n4 mr-3 text-white",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.clear_notification_list();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])])]), _vm._v(" "), _c('perfect-scrollbar', {
    staticStyle: {
      "height": "234px"
    }
  }, [_c('b-list-group', {
    staticStyle: {
      "height": "250px",
      "width": "500px"
    }
  }, [_vm._l(_vm.notification_list.slice(-50).reverse(), function (data) {
    return [_c('b-list-group-item', {
      staticClass: "media d-flex align-items-center"
    }, [_c('i', {
      staticClass: "fa fa-bell d-block ui-w-40 rounded-circle",
      staticStyle: {
        "font-size": "200%"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "media-body ml-3"
    }, [_c('div', {
      staticClass: "text-dark line-height-condenced"
    }, [_vm._v(_vm._s(data.title))]), _vm._v(" "), _c('div', {
      staticClass: "text-light small mt-1"
    }, [_vm._v(_vm._s(data.text))])])])];
  })], 2)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "d-block text-center text-light small p-2 my-1",
    attrs: {
      "to": '/alarm/alarm-tracking',
      "exact": true
    }
  }, [_vm._v(_vm._s(_vm.$t('show_all_notifications')))])], 2)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3"
  }, [_vm._v("|")]), _vm._v(" "), _c('b-nav-item-dropdown', {
    staticClass: "demo-navbar-user"
  }, [_c('template', {
    slot: "button-content"
  }, [_c('span', {
    staticClass: "d-inline-flex flex-lg-row-reverse align-items-center align-middle"
  }, [_c('img', {
    staticClass: "d-block rounded-circle lang_icon",
    attrs: {
      "src": _vm.langFlag,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('b-dd-item', {
    on: {
      "click": function click($event) {
        return _vm.changeLanguage('tr');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.publicUrl, "img/flags/tr.png"),
      "width": "25px"
    }
  }), _vm._v("   Türkçe ")]), _vm._v(" "), _c('b-dd-item', {
    on: {
      "click": function click($event) {
        return _vm.changeLanguage('en');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.publicUrl, "img/flags/en.png"),
      "width": "25px"
    }
  }), _vm._v("   English ")]), _vm._v(" "), _c('b-dd-item', {
    on: {
      "click": function click($event) {
        return _vm.changeLanguage('de');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.publicUrl, "img/flags/de.png"),
      "width": "25px"
    }
  }), _vm._v("   Deutsche ")]), _vm._v(" "), _c('b-dd-item', {
    on: {
      "click": function click($event) {
        return _vm.changeLanguage('ar');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "".concat(_vm.publicUrl, "img/flags/ar.png"),
      "width": "25px"
    }
  }), _vm._v("   عربى ")])], 2), _vm._v(" "), _c('b-nav-item-dropdown', {
    staticClass: "demo-navbar-user",
    attrs: {
      "right": !_vm.isRTL
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('span', {
    staticClass: "d-inline-flex flex-lg-row-reverse align-items-center align-middle"
  }, [_c('img', {
    staticClass: "d-block ui-w-30 rounded-circle",
    attrs: {
      "src": "".concat(_vm.publicUrl, "img/avatars/1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "px-1 mr-lg-2 ml-2 ml-lg-0"
  }, [_vm._v(_vm._s(_vm.user.profile.first_name + ' ' + _vm.user.profile.last_name))])])]), _vm._v(" "), _c('b-dd-item', {
    attrs: {
      "active": _vm.$route.name === 'account-settings',
      "to": {
        name: 'account-settings'
      }
    }
  }, [_c('i', {
    staticClass: "ion ion-md-settings text-lightest"
  }), _vm._v("  \n          " + _vm._s(_vm.$t('settings')) + "\n        ")]), _vm._v(" "), _vm.showVehicleSettings ? _c('b-dd-item', {
    on: {
      "click": _vm.showVehicleSettingsModal
    }
  }, [_c('i', {
    staticClass: "fas fa-car"
  }), _vm._v("  \n          " + _vm._s(_vm.$t('map_settings')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('b-dd-item', {
    attrs: {
      "active": _vm.$route.name === 'request-support',
      "to": {
        name: 'request-support'
      }
    }
  }, [_c('i', {
    staticClass: "ion ion-md-mail text-lightest"
  }), _vm._v("  \n          " + _vm._s(_vm.$t('request_support')) + "\n        ")]), _vm._v(" "), _c('b-dd-item', {
    on: {
      "click": function click($event) {
        return _vm.logout();
      }
    }
  }, [_c('i', {
    staticClass: "ion ion-ios-log-out text-danger"
  }), _vm._v("  \n          " + _vm._s(_vm.$t('sign_out')) + "\n        ")])], 2)], 2)], 1), _vm._v(" "), _c('b-modal', {
    ref: "vehicle_settings_modal",
    attrs: {
      "name": "car-settings",
      "id": "car-settings-modal",
      "size": 'xl',
      "hide-footer": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('car_settings')) + "\n    ")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row mb-2"
  }, _vm._l(_vm.tempVehicleSettings, function (row, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-2 mb-5"
    }, [_c('b-checkbox', {
      on: {
        "change": function change($event) {
          return _vm.changeVehicleSettings(row.field);
        }
      },
      model: {
        value: row.value,
        callback: function callback($$v) {
          _vm.$set(row, "value", $$v);
        },
        expression: "row.value"
      }
    }, [_vm._v(_vm._s(row.label))])], 1);
  }), 0), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "btn btn-danger pull-right ml-1"
    },
    on: {
      "click": _vm.cancelVehicleSettings
    }
  }, [_c('i', {
    staticClass: "fas fa-times mr-1"
  }), _vm._v("\n        " + _vm._s(_vm.$t('cancel')) + "\n      ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "btn btn-success pull-right"
    },
    on: {
      "click": _vm.saveVehicleSettings
    }
  }, [_c('i', {
    staticClass: "fas fa-save mr-1"
  }), _vm._v("\n        " + _vm._s(_vm.$t('save')) + "\n      ")])], 1), _vm._v(" "), _c('custom-loading', {
    attrs: {
      "isLoading": _vm.isSettingsLoading,
      "fullPage": true
    }
  })], 1), _vm._v(" "), _vm.showVehicleSettings ? _c('map-settings', {
    attrs: {
      "modalShow": _vm.showsettings
    },
    on: {
      "close": _vm.close
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }